import React, { useState } from 'react'

function AdminLogin({ setAdminKey }) {
    const [ adminKeyInput, setAdminKeyInput ] = useState("")
    const [ showModal, setShowModal ] = useState(false)

    const handleLogin = event => {
        event.preventDefault()

        fetch("/api/admin/auth-ok", {
            headers: {
                "x-admin-key": adminKeyInput
            }
        })
            .then(r => {
                if (r.ok) {
                    setAdminKey(adminKeyInput)
                }
                else {
                    setShowModal(true)
                }
            })
    }

    const handleAdminKeyInput = event => {
        setAdminKeyInput(event.target.value)
    }

    return (
        <div>
            <hgroup>
                <h1>Admin login</h1>
                <h2>Bitte Admin Token angeben</h2>
            </hgroup>
            <form onSubmit={handleLogin}>
                <input 
                    type="text" 
                    name="admin-token" 
                    placeholder="Admin Token"
                    value={adminKeyInput}
                    onChange={handleAdminKeyInput}
                />
                <button type="submit">Log in</button>
            </form>
            { showModal && showModal === true && (
                <dialog open>
                    <article>
                        <header>Nope</header>
                        <p>Admin Token ist nicht gültig</p>
                        <footer>
                            <a href="#" role="button" onClick={() => setShowModal(false)}>Ok</a>
                        </footer>
                    </article>
                </dialog>
            )}
        </div>
    )
}

export default AdminLogin;